module.exports = __webpack_public_path__ + "static/img/SY.19cb88f7.png";